
export const USERS = {
    login: "login",
    users: "users",
    // userRoutes: "users/{username}",
    userRoutes: "users/{username}/{date}",
    adduser: "adduser",
    changePassword: "users/{username}/password",
    history: "users/{username}/password-history"
}